/*import Swal from 'sweetalert2'*/

/*
    Loaded only in the product page
*/

// Shopify resize image
// https://gist.github.com/DanWebb/cce6ab34dd521fcac6ba

var upload_photo_url = "";

window.resizeImage = (src, size, crop = '') => src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
.replace(/\.jpg|\.png|\.gif|\.jpeg/g, (match) => {
    if (crop.length) {
        // eslint-disable-next-line no-param-reassign
        crop = `_crop_${crop}`;
    }
    return `_${size}${crop}${match}`;
});


//Updates the PDP price when a bundle 'variant' selected is higher than the base price
/*
function adjustPDPPriceChange() {
  var priceLabel = document.querySelector(".product__price span[data-price]");//main bundle price object

  if (priceLabel !== null) {
    if (priceLabel.classList.contains("pseudo-bundle-price")){
      var selectElement = document.getElementById("variant-selector");
      var selectedAnimPriceData = selectElement.options[selectElement.selectedIndex].dataset.variantPrice;
      var selectedAnimPrice = Number(selectedAnimPriceData.replace('$', ''));

      priceLabel.textContent = "$" + (selectedAnimPrice + Number(priceLabel.dataset.bundlePrice)) + ".00"
    } else {
      var selectedOption = document.getElementById("variant-selector").options[document.getElementById("variant-selector").selectedIndex];

      if ( selectedOption.getAttribute('data-variant-price') != priceLabel.textContent ) { //if the bundle prices are different
        priceLabel.textContent = selectedOption.getAttribute('data-variant-price');

        
        if ( document.querySelector(".pdp-member-price") !== null) {//if user is member with discount
          var memberPrice = parseFloat(document.querySelector(".product__price span[data-price]").textContent.replace(/[^\d.-]/g, "")) * .75
          document.querySelector(".pdp-member-price").textContent = "$" + memberPrice.toFixed(2)
        }
        
      }

    }
  }

}
  */

//Updates the PDP form's drop down selector for variants and initiates adjustPDPPriceChange()
function swatchSelectUpdate(e){
  var isButton = e.target.nodeName === 'BUTTON';
  if (!isButton){
    return
  }else{
    document.querySelectorAll(".product__color-swatch.selected").forEach((swatch) => {
      swatch.classList.remove("selected");
    })
    e.target.classList.toggle("selected");
    var variantSelector = document.getElementById('variant-selector');

    //variantSelector.value = selectedSwatch.value;
    variantSelector.value = e.target.value;
    updateATCDynamicPrice(); //update regardless of PD to 'reset' price
    if (document.querySelector(".gaf-template #swatchSelection")) {
      let newLabel = document.querySelector(".product__color-swatch.selected").dataset.label;
      document.querySelector(".gaf-template #variantName").textContent = newLabel;
    }
  }
}

//Prevent Default on ATC button
function preventATCDefault() {
  document.querySelector('form[action="/cart/add"]').addEventListener("submit", function(event) {
    event.preventDefault(); // Prevent the default form submission
  
    document.getElementById("myModal").style.display = "block";
  });
  
  // Close the modal when the close button is clicked
  /*document.getElementById("closeModal").addEventListener("click", function() {
    document.getElementById("myModal").style.display = "none";
  });*/

}

//Focuses and opens Upsell Modal
function upsellModalFocus(){
  /*Open the upsell modal*/
  var upsellModal = document.getElementById('upsell-modal__bg');
  upsellModal.style.display = 'flex';
  document.body.style.overflowY = 'hidden';

  /*Focus on the upsell modal*/
  const  focusableElements =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
  const modal = document.querySelector('#upsell-modal');

  jQuery.getJSON('/cart.js', function(cart) {
    document.querySelector('span[data-js-cart-count]').textContent = parseFloat(cart.item_count);
  });

  const firstFocusableElement = modal.querySelectorAll(focusableElements)[0];
  const focusableContent = modal.querySelectorAll(focusableElements);
  const lastFocusableElement = focusableContent[focusableContent.length - 1];


  document.addEventListener('keydown', function(e) {
    let isTabPressed = e.key === 'Tab' || e.keyCode === 9;
    if (!isTabPressed) {
      return;
    }
    if (e.shiftKey) { // if shift key pressed for shift + tab combination
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus(); // add focus for the last focusable element
        e.preventDefault();
      }
    } else { // if tab key is pressed
      if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
        firstFocusableElement.focus(); // add focus for the first focusable element
        e.preventDefault();
      }
    }
  });

  firstFocusableElement.focus();
}

window.addEventListener("load", function() {
  //Close modal when modal bg is clicked
  if (document.querySelector(".upsell-modal__bg") !== null){
    document.querySelector(".upsell-modal__bg").addEventListener("click", function(e) {
      if (e.target === e.currentTarget){
        closeModalRoutine();
      }
    })

    //Allows modal to close when escape key is pressed
    document.addEventListener('keydown', (e) => {
      if (e.key === "Escape" && document.getElementById("upsell-modal__bg").style.display == "flex"){
        closeModalRoutine();
      }
    })
  }
});

function submitATCForm(product) {
  const isGAF = ["GiveAFriend", "GiveAFriend Campaign"].includes(product.type);

  // Get selected variant ID (fall back to first variant)
  let varId;
  const selectedVariant = document.querySelector('select[name="id"] option:checked');
  if (selectedVariant) {
    varId = selectedVariant.value;
  } else {
    varId = product.variants[0].id;
  }

  let formData;

  // GAF products with single variant → submit form directly
  if (product.variants.length <= 1 && isGAF) {
    const gafForm = document.querySelector('form[action="/cart/add"]');
    if (gafForm) gafForm.submit();
    return; // stop here, no AJAX call
  }

  // GAF products with multiple variants → quantity from page
  if (product.variants.length > 1 && isGAF) {
    const qtyEl = document.querySelector("[data-gaf-campaign-qty-text]");
    const quantity = qtyEl ? parseInt(qtyEl.innerText.replace(/(\d+).*/, "$1"), 10) : 1;
    formData = { items: [{ id: varId, quantity }] };

  // All other products
  } else {
    formData = { items: [{ id: varId, quantity: 1 }] };
  }

  // Send to cart
  jQuery.post(`${window.Shopify.routes.root}cart/add.js`, formData, function (data, status) {
    if (status === "success") {
      window.location.href = "/cart";
    }
  }, "json");
}



function submitATCFormModal(product, tagged, bundle_upsell_metafield) {
  if (!product.available) return;

  // Precompute flags
  const hasCard = product.tags.includes('card_include');
  const isCardExcluded = product.tags.includes('card_exclude');
  const isCardOptional = product.tags.includes('card_optional');
  const isBundle = product.type === "Bundle";
  const isGAF = ["GiveAFriend", "GiveAFriend Campaign"].includes(product.type);

  // Cache DOM
  const cardTextarea = document.getElementById('greetingCardTextarea');
  const cardErrorText = document.getElementById('greetingCardError');
  const pseudoBundleInfo = document.querySelector(".pseudo-bundle-info");
  const selectedVariant = document.querySelector('select[name="id"] option:checked');

  // Helper for cart items
  const makeItem = (id, qty, props = {}) => ({ id, quantity: qty, properties: props });

  // Greeting card validation
  if (hasCard && !isCardExcluded) {
    let error = false;

    if (!isCardOptional) {
      const trimmedMsg = cardTextarea.value.trim().customTrim();
      if (!trimmedMsg || trimmedMsg === ".") {
        error = "Please write a notecard before you continue.";
        cardErrorText.classList.remove("error");
        cardTextarea.classList.add('notecardError');

        if (cardTextarea.placeholder === "Don’t skip this part! Say something from the heart 💙" &&
            document.querySelector('.suggestion-wrapper').style.display === 'none') {
          document.getElementById('theseIdeas').click();
        }
        cardTextarea.focus();
      }
    }

    if (cardTextarea.value.length > 400) {
      error = "Custom note can't be longer than 400 characters long";
    }

    if (error) {
      cardErrorText.innerHTML = error;
      cardErrorText.classList.add("error");
      document.querySelector('.customization_label')
        .scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    }
  }

  // Determine variant / bundle IDs
  let varId, bundleId;
  if (product.variants.length > 1 && !pseudoBundleInfo) {
    varId = selectedVariant?.value;
  } else if (pseudoBundleInfo) {
    bundleId = pseudoBundleInfo.dataset.bundleId;
  } else {
    varId = product.variants[0].id;
  }

  // Build formData
  let formData;

  if (hasCard) {
    const notecardMsg = cardTextarea.value.trim().customTrim();

    if (isBundle && product.variants.length <= 1 && !pseudoBundleInfo) {
      formData = { items: [makeItem(varId, 1, { 'Personalized Card': notecardMsg })] };

    } else if (isBundle && pseudoBundleInfo) {
      const swatch = document.querySelector(".product__color-swatch.selected");
      if (!swatch) {
        handleUnselectedSwatchError();
        return false;
      }
      const chosenAnimal = swatch.dataset.animalHandle;
      const animalId = selectedVariant?.value;

      formData = {
        items: [
          makeItem(bundleId, 1, { '_goes-with-animal': chosenAnimal }),
          makeItem(animalId, 1, { 'Personalized Card': notecardMsg })
        ]
      };

    } else {
      formData = { items: [makeItem(varId, 1, { 'Personalized Card': notecardMsg })] };
    }

  } else if (product.variants.length <= 1 && isGAF) {
    document.querySelector('form[action="/cart/add"]')?.submit();
    return;

  } else if (product.variants.length > 1 && isGAF) {
    const quantityText = document.querySelector("[data-gaf-campaign-qty-text]")?.innerText || "1";
    const quantity = parseInt(quantityText.replace(/(\d+).*/, '$1'), 10);
    formData = { items: [makeItem(varId, quantity)] };

  } else {
    formData = { items: [makeItem(varId, 1)] };
  }

  // Add to cart
  jQuery.post(`${window.Shopify.routes.root}cart/add.js`, formData, function (data, status) {
    if (status === "success") {
      window.location.href = "/cart";
    }
  }, "json");
}



//Functions/Listeners to add when DOM is loaded
window.addEventListener("load", function() {
  //Adds event listeners to swatches to call swatchSelectUpdate when a new swatch is selected
  if (document.querySelector(".product-form__color-swatches") !== null) {
    document.querySelector(".product-form__color-swatches").addEventListener("click", (event) => {swatchSelectUpdate(event)})
  }

  // Handle bundle variant price descrepancies
  /*if (document.querySelector(".product-form__variants .select-wrapper:not(.upsell-prop-input) select#variant-selector") !== null) {
    document.querySelector(".product-form__variants .select-wrapper:not(.upsell-prop-input) select#variant-selector").addEventListener('change', (event) => {
      adjustPDPPriceChange(event);
    });
  }*/
 //adds eventListeners to zoom upsell photos
  document.querySelectorAll(".upsell-upsell__img-wrapper").forEach((e) => {
    e.addEventListener("click", function() {
      photoZoomFunctionality(e);
    });
  });

  jdgmePhotoSizeChanger();
});

/* START add-on recommendations */
function findCategories(text) {
  const flaggedCategories = {
    'moon-back-add-on': ['i love you to', 'moon', 'special'],
    'deluxe-moon-back-bundle': ['i love you to', 'moon', 'special'],
    'thinking-of-you-addon': ['thinking of you', 'missing you', 'miss you', 'cheer', 'proud', 'you got this'],
    'bday-add-on': ['birthday', 'birth', 'bday', 'b-day'],
    'self-care-add-on': ['take care', 'get better', 'hard time', 'relax', 'comfort', 'strong', 'care'],
    'deluxe-self-care-add-on': ['take care', 'get better', 'hard time', 'relax', 'comfort', 'strong', 'care'],
    'you-are-my-sunshine-add-on': ['sun', 'little reminder'],
    'deluxe-sunshine-bundle': ['sun', 'little reminder']
  };
  const matchedCategories = [];

  for (const category in flaggedCategories) {
    const containsFlaggedMsg = flaggedCategories[category].some(keyword => text.includes(keyword));
    
    if (containsFlaggedMsg) {
      matchedCategories.push(category); // Add matched category to the array
    }
  }
  
  return matchedCategories; // Return all matched categories
}

function prependAddonTopOfList(addonHandle) {
  const addon = document.querySelector("li." + addonHandle);
  const upsellList = document.querySelector(".upsell-modal__upsell-list");
  
  if (addon && upsellList) {
    upsellList.prepend(addon);
  }
}

function checkForAddonRecs(msg) {
  const msgText = msg.value.toLowerCase();
  const detectedCategories = findCategories(msgText);
  
  if (detectedCategories.length > 0) {
    detectedCategories.forEach(category => {
      prependAddonTopOfList(category);
    });
  }
}

/*JS Scripting for functions in the upsell modal*/


//API call to retrieve cart information (for testing purposes only)
/*function printCart() {
  jQuery.getJSON('/cart.js', function(cart) {
    //console.log('PRINTCART')
    cart.items.forEach( item => {
      console.log(item)
    })
    console.log("Print cart: ", cart.items);
  });
}*/

/*
function getProdHandleFromURL() {
  const currentURL = window.location.href;
  const regex = /https:\/\/sendafriend\.co\/products\/([^?]+)/;
  
  return currentURL.match(regex)[1];  
}*/

/*API gets item count in cart and updates number in header cart icon*/
function updateCartCount() {
  jQuery.getJSON('/cart.js', function(cart) {
    document.querySelector('span[data-js-cart-count]').textContent = parseFloat(cart.item_count);
  });
  if (document.querySelector(".upsell-modal__content #product-notecard") !== null) {
    updateATCDynamicPrice();
  }
}

/*-------- Resets variant selector after modal close --------*/
function resetVariant() {
  const selectedSwatch = document.querySelector(".product__color-swatch.selected")
  const variantSelector = document.getElementById('variant-selector');
  if (variantSelector !== null && selectedSwatch !== null) {
    variantSelector.value = selectedSwatch.value;
  }
}
/*----------------*/

//Allows modal to close when escape key is pressed
document.addEventListener('keydown', (e) => {
  if (e.key === "Escape" && document.getElementById("upsell-modal__bg").style.display == "flex"){
    closeModalRoutine();
  }
})

//Initiates the routine to 'reset' the modal and remove selected products when modal is closed
function closeModalRoutine() {
  removeAnimFromCart();
  document.getElementById("upsell-modal__bg").style.display = "none";
  document.body.style.overflowY = "unset";
  updateCartCount();

  const variantSelector = document.getElementById('variant-selector');
  if (variantSelector !== null && variantSelector !== undefined) {
    resetVariant();
  }
}

/*Add upsells to cart the calls addProducts() OLD*/
/*function addUpsells(upsells){
  if(upsells.length > 0){
    let formData = {'items': upsells};
    jQuery.post(window.Shopify.routes.root + 'cart/add.js', formData, function(data, status){
      if(status === "success"){
        addProducts();
      }
    },"json")
  } else {
    addProducts();
  }
}*/

//Fetches JSON for product with given handle (for testing purposes only)
/*function getProductInfo(prodHandle) {
  jQuery.getJSON('/products/' + prodHandle + '.js', function(json) {
    callback(json);
  });
}*/

//Fetches product info given a handle and returns a promise
function getProductInfo(prodHandle) {
  const promise = fetch(window.Shopify.routes.root + 'products/' + prodHandle + '.js')
    .then(response => response.json())
    .catch(error => {
      console.error('Error fetching product info:', error);
      throw error;
    });
  return { promise };
}

//Removes main animal product from cart
function removeAnimFromCart() {
  removeUpsellsViaExiting();
  /*if (document.querySelector(".pseudo-bundle-info") !== null){
    removeBundleAndAnimFromCart()
  } else {
    removeNonBundleFromCart()
  }*/
}

//removes the animal and bundle upsell item for psueo bundle PDPs
function removeBundleAndAnimFromCart() {
  var productHandle = document.getElementById('product__type-data').getAttribute('data-product-handle');
  var notecardText = document.querySelector('.greeting-card_textarea').value;
  var animalHandle = '';
  if (document.querySelector('.product__color-swatch.selected') !== null) {
    var animalHandle = document.querySelector('.product__color-swatch.selected').dataset.animalHandle;
  }
  
  

  jQuery.getJSON('/cart.js', function(cart) {
    var formData = { 'updates': {}};
    
    collectItemInfoCart(cart.items).forEach( item => {
      if (
        (item.handle == productHandle && item.properties['_goes-with-animal'] == animalHandle) ||
        (item.handle == animalHandle && item.properties['Personalized Card'] == notecardText )
      ) {
        var productKey = item.key;
        var productQuantity = item.quantity - 1;

        formData.updates[productKey] = productQuantity;
      }
    })
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      removeUpsellsViaExiting();
      return response.json();
    })
    .catch((error) => {
    });
  });

}

//API call to remove non-bundle (ie animal) products from cart when modal is exited
function removeNonBundleFromCart() {
  var notecardText = document.querySelector('.greeting-card_textarea').value;
  var animalKey = '';
  
  var animalHandle = document.getElementById('product__type-data').getAttribute('data-product-handle')
  var animalQuantity = 0;

  jQuery.getJSON('/cart.js', function(cart) {
    collectItemInfoCart(cart.items).forEach( item => {
      if (item.handle == animalHandle && item.properties['Personalized Card'] == notecardText) {
        var animalKey = item.key;
        var animalQuantity = item.quantity - 1;

        var updates = {}
        updates[animalKey] = animalQuantity;

        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates })
        })
        .then(response => {
          removeUpsellsViaExiting();
          //updateCartCount();
          return response.json();
        })
        .catch((error) => {
        });
      }
    })      
  });
}


//Determines if upsell is being added or removed
function updateUpsellCart(elem, prodHandle) {
  if (elem.classList.contains('addUpsell')) {
    addUpsell(elem, prodHandle);
  } else if (elem.classList.contains('removeUpsell')) {
    if (prodHandle == "custom-framed-4x6-photo") {
      removeFileUpload(elem, prodHandle);
    } else {
      removeOneUpsell(elem, prodHandle);
    }
  }
}

//Add upsell to cart
function addUpsell(elem, upsellHandle){
  var { promise } = getProductInfo(upsellHandle);

  promise.then(product => {
    if (product.handle.toLowerCase() == "dont-open-until-sticker") {
      if (verifyDOUNote(elem)) {
        var douTextbox = document.getElementById('DOU_sticker');
        var formData = { 'items': [{
          'id': product.variants[0].id,
          'quantity': 1,
          'properties': {
            'note': douTextbox.value
          }}
        ]}
    
        jQuery.post(window.Shopify.routes.root + 'cart/add.js', formData, function(data, status){
          if(status === "success"){
            elem.classList.replace('addUpsell', 'removeUpsell');
            elem.innerText = "Remove"
            douTextbox.disabled = true;
            updateCartCount();
          }
        },"json")
      }
    } else if (product.id == 7118807990369) { 
      var sizeSelector = document.getElementById("upsell-variant-selector");
      var formData = { 'items': [{
        'id': sizeSelector.value,
        'quantity': 1 }
      ]}
      jQuery.post(window.Shopify.routes.root + 'cart/add.js', formData, function(data, status){
        if(status === "success"){
          elem.classList.replace('addUpsell', 'removeUpsell');
          sizeSelector.disabled = true;
          elem.innerText = "Remove"
          updateCartCount();
        }
      },"json")
    } else if (product.tags.includes("file_upload_product") && upload_photo_url === "") {
      document.querySelector('[id^="filepond--drop-label-"]').click();
      elem.classList.add("uploading");
    } else if (product.tags.includes("file_upload_product")) {
      if (verifyFileUpload(elem)){      
        var formData = { 'items': [{
          'id': product.variants[0].id,
          'quantity': 1,
          'properties': {
            'Photo': upload_photo_url
            }
          }
        ]}
        jQuery.post(window.Shopify.routes.root + 'cart/add.js', formData, function(data, status){
          if(status === "success"){
            elem.classList.replace('addUpsell', 'removeUpsell');
            elem.innerText = "Remove";
            elem.classList.remove("uploading");
            updateCartCount();
          }
        },"json")
      }
    } else {
      var formData = { 'items': [{
        'id': product.variants[0].id,
        'quantity': 1 }
      ]}
      jQuery.post(window.Shopify.routes.root + 'cart/add.js', formData, function(data, status){
        if(status === "success"){
          elem.classList.replace('addUpsell', 'removeUpsell');
          elem.innerText = "Remove";
          updateCartCount();
        }
      },"json")
    }
  });  
}

//Gets the handle, key, quantity, and properties of all items in cart
function collectItemInfoCart(items) {
  var collectedInfo = [];

  items.forEach(function(item) {
    var itemInfo = {
      id: item.variant_id,
      handle: item.handle,
      key: item.key,
      quantity: item.quantity,
      properties: item.properties
    };
    collectedInfo.push(itemInfo);
  });

  return collectedInfo;
}

//Removes upsell from cart
function removeOneUpsell(elem, prodHandle) {
  if (prodHandle == "custom-framed-4x6-photo") {
    removeFileUpload(elem, prodHandle)
  } else {
    jQuery.getJSON('/cart.js', function(cart) {
      var cartItems = collectItemInfoCart(cart.items);
      cartItems.forEach( item => {
        if (item.handle == prodHandle) {
          var id = item.key;
          var quantity = item.quantity - 1;
          var formData = { 'id': id, 'quantity': quantity.toString() }

          jQuery.post(window.Shopify.routes.root + 'cart/change.js', formData, function(data, status){
            if(status === "success"){
              elem.classList.replace('removeUpsell', 'addUpsell');
              elem.innerText = "Add to Package +" + elem.getAttribute("upsell-price");
              
              if (prodHandle.toLowerCase() == 'dont-open-until-sticker') {
                var douTextbox = document.getElementById('DOU_sticker');
                douTextbox.classList.remove('douAdded');
                douTextbox.disabled = false;
              } else if (prodHandle.toLowerCase() == 'someone-loves-you-hoodie-for-human') {
                var sizeSelector = document.getElementById("upsell-variant-selector");
                sizeSelector.disabled = false;
              }
              if (elem.closest("li").classList.contains("fileUploader")){
                if (elem.closest("li").querySelector('.upload-lift input[name="properties[Photo]"]') !== null){
                  elem.closest("li").querySelector(".filepond--action-revert-item-processing").click();
                }
              }
              updateCartCount();
            } else {
            }
          });
        }
      })
    });
  }
}

//Resets the styling for all upsell "Add" buttons when modal is exited
function resetUpsellButtons(buttonList) {
  buttonList.forEach( btn => {
    btn.classList.replace('removeUpsell', 'addUpsell');
    btn.innerText = "Add to Package +" + btn.getAttribute("upsell-price");
  
    //var lowercaseClasses = Array.from(btn.closest("li").classList).map(className => className.toLowerCase());
    var lowercaseClasses = btn.closest("li").classList[0];
    if (lowercaseClasses == 'dont-open-until-sticker') {
      var douTextbox = document.getElementById('DOU_sticker');
      douTextbox.classList.remove('douAdded');
      douTextbox.disabled = false;
    }
  })

}

//Removes all upsells from cart if exiting upsell modal
function removeUpsellsViaExiting() {
  var upsellsToRemove = [];

  document.querySelectorAll(".upsell-upsell__add-rmv-btn.removeUpsell").forEach( upsell=> {
    upsellsToRemove.push(upsell.closest("li").classList[0])
  })

  if (upsellsToRemove.length > 0){
    jQuery.getJSON('/cart.js', function(cart) {
      var updates = {}
      collectItemInfoCart(cart.items).forEach( item => {
        if (upsellsToRemove.includes(item.handle.toLowerCase())) {
          var upsellKey = item.key;
          var upsellQuantity = item.quantity - 1;

          updates[item.id] = item.quantity - 1;
          
        }
      })      
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates })
      })
      .then(response => {
        resetUpsellButtons(document.querySelectorAll(".upsell-upsell__add-rmv-btn.removeUpsell"))
        updateCartCount();
        return response.json();
      })
      .catch((error) => {
      });
    });
  } else {
    updateCartCount();
  }
}

/* Shows/hides the upsells in modal according to selected size */
function updateUpsellsForAnimSize(){
  //get selected size
  let selectedSize = document.querySelector('div.size-selector_wrapper div.selected')
  //if it is not the original size
  if(!selectedSize.classList.contains('original')){
    //hide the upsells in the no sell list
    document.querySelectorAll('li.upsellHide').forEach(e => {
      e.setAttribute('id','upsellHide');
    })
  }else{//it's the original and we need to remove any #upsellHide
    document.querySelectorAll('li.upsellHide').forEach(e => {
      e.removeAttribute('id');
    })
  }
}

function updateATCDynamicPrice() {
  var prod_price = 0;
  var upsells_total_price = 0;
  var currency_symbol = "$";

  //get prod price
  var modal_atc_btn = document.querySelector(".upsell-modal__cart-btn.product-form__cart-submit");
  if (modal_atc_btn !== null) {
    var price = modal_atc_btn.getAttribute("prod-base-price");
    prod_price = Number(price.replace(/[^0-9\.-]+/g,""));
    currency_symbol = price.replace(/[\d,.\s]/g, "");
  }



  //get list of added upsell prices
  if (document.querySelectorAll(".removeUpsell") !== null) {
    var upsells_added_list = document.querySelectorAll(".removeUpsell");
    upsells_added_list.forEach((upsell) => {
      var price = upsell.getAttribute("upsell-price")
      var number = Number(price.replace(/[^0-9\.-]+/g,""));
      upsells_total_price += number;
    });
  }
  
  //add the prices together
  var package_price = 0;
  
  if (document.querySelector(".upsell-modal__content .product-form__color-swatches") !== null) {//if it has swatches
    var selected_swatch_price_diff = 0;
    if (document.querySelector(".product__color-swatch.selected") !== null){
       selected_swatch_price_diff = Number(document.querySelector(".product__color-swatch.selected").getAttribute("pd"));
    }

    package_price = (prod_price + upsells_total_price + selected_swatch_price_diff).toFixed(2);
  } else {
    package_price = (prod_price + upsells_total_price).toFixed(2);
  }
  //apply to the atc btn
  if (document.querySelector("#upsell-modal__total-price")){
    document.querySelector("#upsell-modal__total-price").innerText = currency_symbol + package_price;
  }
  
}

function handleUnselectedSwatchError() {
  var swatchErrorMsg = document.querySelector("#swatchSelectorError");
  const error = "Please select an animal before you continue.";
  swatchErrorMsg.innerHTML = error;
  swatchErrorMsg.setAttribute('aria-label', error);
  swatchErrorMsg.style.color = "red";
  swatchErrorMsg.style.display = 'block';
  swatchErrorMsg.classList.add('notecardError');

  var modal = document.querySelector('.upsell-modal__content'); // Select the modal
  var errorElement = document.querySelector('.product-form__label[for="variant-selector"');

  if (modal && errorElement) {
    var modalScrollTop = modal.scrollTop; // Get current scroll position inside the modal
    var offsetTop = errorElement.getBoundingClientRect().top - modal.getBoundingClientRect().top;

    modal.scrollTo({
      top: modalScrollTop + offsetTop - 150,
      behavior: 'smooth'
    });
  }
  swatchErrorMsg.focus();
}


/*----------- Upload-lift START -----------*/
/* attach event listener to the product form */
window.addEventListener('upload:added', function(e) {
  var file = e.detail;
  if (e.target.closest('.upsell-modal') !== null) {
    let selector = "[value=\"" + file.url + "\"]";
  
    const upsell_elem = document.querySelector(selector).closest(".upsell-modal__upsell");
    const upsell_handle = upsell_elem.getAttribute("data-upsell-product");
    const upsell_add_btn = upsell_elem.querySelector(".upsell-upsell__add-rmv-btn");
  
    upload_photo_url = file.url;
    
    upsell_elem.querySelector(".upload-lift").setAttribute("data-has-upload", "true");
    
    if (upsell_add_btn.classList.contains('addUpsell')) {
      addUpsell(upsell_add_btn, upsell_handle);
    }
  }
});

window.addEventListener('upload:removed', function(e) {
  let file = e.detail;
  let temp_photo_url = upload_photo_url;
  upload_photo_url = "";
  

  document.querySelectorAll("li.fileUploader").forEach(e => {
    let uploader = e.querySelector(".upload-lift");
    let atp_btn = e.querySelector(".upsell-upsell__add-rmv-btn");
    
    if (uploader.querySelector('input[name="properties[Photo]"]') === null && atp_btn.classList.contains('removeUpsell')) {
      upsell_elem = e;
      upsell_elem.querySelector(".upload-lift").setAttribute("data-has-upload", "false");
      const upsell_handle = upsell_elem.querySelector(".upsell-modal__upsell").getAttribute("data-upsell-product");
      //removeOneUpsell(atp_btn, upsell_handle);
      removeFileUpload(atp_btn, upsell_handle, temp_photo_url);
    }
  })
});

//Checks if file is finished uploading and creates error message
function verifyFileUpload(elem) {
  const errorElem = elem.parentElement.querySelector('.customization_error');

  if (upload_photo_url.length >= 4) {
    errorElem.text = "";
    errorElem.setAttribute('aria-label', "");
    errorElem.style.display = 'none';

    return true;
  } else {
    const errorMsg = "Please upload a photo before adding this to your package";
    errorElem.innerHTML = errorMsg;
    errorElem.setAttribute('aria-label', errorMsg);
    errorElem.style.color = "#C1272F";
    errorElem.style.display = 'block';
    
    return false;
  }
}

function removeFileUpload(elem, prodHandle, photoURL) {

  if (!photoURL) {
    photoURL = upload_photo_url;
  }

  jQuery.getJSON('/cart.js', function(cart) {
    var cartItems = collectItemInfoCart(cart.items);
    cartItems.forEach(item => {
      if (item.handle == prodHandle && item.properties['Photo'] == photoURL) {
        var id = item.key;
        var quantity = item.quantity - 1;
        var formData = { 'id': id, 'quantity': quantity.toString() };

        jQuery.post(window.Shopify.routes.root + 'cart/change.js', formData, function(data, status) {
          if (status === "success") {
            elem.classList.replace('removeUpsell', 'addUpsell');
            elem.innerText = "Add to Package +" + elem.getAttribute("upsell-price");

            if (elem.closest("li").classList.contains("fileUploader")) {
              const revertBtn = elem.closest("li").querySelector(".filepond--action-revert-item-processing");
              if (revertBtn) {
                revertBtn.click();
              }
            }
            updateCartCount();
          } 
        });
      }
    });
  });
}

/*----------- Upload-lift END -----------*/

//Checks if DOU stickers are filled out correctly
function verifyDOUNote(douBtn) {
  // Find the nearest upsell container for this button
  var container = douBtn.closest('.upsell-modal__upsell');
  if (!container) return false; // safety fallback

  // Find the input and error message inside this container
  var douTextbox = container.querySelector('#DOU_sticker');
  var errorElement = container.querySelector('.customization_error');
  
  if (!douTextbox || !errorElement) return false; // safety fallback

  var value = douTextbox.value.trim();

  if (value === '' || value === "Please add a date.") {
    douTextbox.classList.add('douError');
    errorElement.classList.add('error');
    errorElement.textContent = "Please add a date.";
    //errorElement.style.display = 'block';
    return false;
  } else {
    douTextbox.classList.remove('douError');
    douTextbox.classList.add('douAdded');
    errorElement.classList.remove('error');
    errorElement.textContent = "";
    //errorElement.style.display = 'none';
    return true;
  }
}


function photoZoomFunctionality(elem) {
  let parent = elem.closest(".upsell-item-top")
  parent.classList.toggle("zoom-upsell");
}

function jdgmePhotoSizeChanger() {
  // Select all images with the class 'jdgm-rev__pic-img'
  var images = document.querySelectorAll('.jdgm-rev__pic-img');

  images.forEach(function(img) {
    // Get current 'data-src' or 'src' of the image
    var currentSrc = img.getAttribute('data-src') || img.getAttribute('src');

    // Replace the width parameter in the URL to request a higher resolution image
    var newSrc = currentSrc.replace(/w=160/g, 'w=1024');

    // Set the new 'src' attribute to the image
    img.setAttribute('src', newSrc);
    img.setAttribute('data-src', newSrc); // Also update 'data-src' if it's used by lazy loading scripts
  });
}
